'use client'

import PropTypes from 'prop-types'
import MUITypography from '@mui/material/Typography'
import { ChevronRightIcon } from '@repo/ui/ChevronRightIcon'
import MUIStack from '@mui/material/Stack'
import MUIIconButton from '@mui/material/IconButton'

export const CarouselNavigation = ({ index, items, onChange, sx, showNumbers = true }) => {
  const incrementIndex = (delta) => {
    if (!onChange) return

    const newIndex = index + delta
    if (newIndex < 0) {
      // start of carousel, reset to last item
      onChange(items.length - 1)
      return
    }

    if (newIndex >= items.length) {
      // end of carousel, reset to first item
      onChange(0)
      return
    }

    // just increment the index
    onChange(newIndex)
  }

  if (!items || items.length < 2) {
    // render an empty div if we don't need to show navigation
    return (
      <MUIStack
        data-testid="CarouselNavigation"
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        gap={2}
        sx={{ ...sx }}
      ></MUIStack>
    )
  }

  return (
    <MUIStack
      data-testid="CarouselNavigation"
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
      gap={showNumbers ? 2 : 0}
      sx={{ ...sx }}
    >
      <MUIIconButton onClick={() => incrementIndex(-1)}>
        <ChevronRightIcon sx={{ transform: 'rotate(180deg)', color: sx?.color || null }} />
      </MUIIconButton>

      {showNumbers ? (
        <MUITypography variant="body1" sx={{ mb: 0, color: sx?.color || 'text.primary' }}>
          {index + 1} / {items.length}
        </MUITypography>
      ) : null}

      <MUIIconButton onClick={() => incrementIndex(1)}>
        <ChevronRightIcon sx={{ transform: 'rotate(0deg)', color: sx?.color || null }} />
      </MUIIconButton>
    </MUIStack>
  )
}

CarouselNavigation.propTypes = {
  index: PropTypes.number,
  items: PropTypes.array,
  onChange: PropTypes.func,
  showNumbers: PropTypes.bool,
  sx: PropTypes.object
}
